import { useQuery } from "@tanstack/react-query";
import { listActiveDelegations } from "../../api/delegation";
import { delegationQueryKeys } from "./delegationQueryKeys";

export const useActiveDelegations = (enabled = true) =>
  useQuery({
    queryKey: delegationQueryKeys.active,
    queryFn: listActiveDelegations,
    enabled,
  });
